import React from 'react';
import { Snackbar, Box, IconButton, Slide } from '@mui/material';
import { Close, CheckCircle, Error, Warning, Info } from '@mui/icons-material';

// Iconos por tipo de notificación
const getNotificationIcon = (severity) => {
  const iconStyle = { marginRight: '8px', fontSize: '18px' };

  switch (severity) {
    case 'success':
      return <CheckCircle sx={{ ...iconStyle, color: '#4caf50' }} />;
    case 'error':
      return <Error sx={{ ...iconStyle, color: '#f44336' }} />;
    case 'warning':
      return <Warning sx={{ ...iconStyle, color: '#ff9800' }} />;
    case 'info':
      return <Info sx={{ ...iconStyle, color: '#2196f3' }} />;
    default:
      return <Info sx={{ ...iconStyle, color: '#2196f3' }} />;
  }
};

const NotificationSnackbar = ({ snackbar, onClose }) => {
  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      TransitionComponent={Slide}
      TransitionProps={{ direction: 'left' }}
    >
      <Box
        sx={{
          background: 'rgb(54, 54, 54)',
          color: 'rgb(255, 255, 255)',
          padding: '12px 16px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          display: 'flex',
          alignItems: 'center',
          minWidth: '300px',
          maxWidth: '500px',
          animation: '0.35s cubic-bezier(0.21, 1.02, 0.73, 1) 0s 1 normal forwards running',
          '@keyframes slideIn': {
            from: { transform: 'translateX(100%)', opacity: 0 },
            to: { transform: 'translateX(0)', opacity: 1 }
          }
        }}
      >
        {/* Icono de la notificación */}
        {getNotificationIcon(snackbar.severity)}

        {/* Mensaje */}
        <Box sx={{ flex: 1, fontSize: '14px', lineHeight: 1.4 }}>
          {snackbar.message}
        </Box>

        {/* Botón de cerrar */}
        <IconButton
          size="small"
          onClick={onClose}
          sx={{
            color: 'rgb(255, 255, 255)',
            marginLeft: '8px',
            padding: '4px',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)'
            }
          }}
        >
          <Close sx={{ fontSize: '18px' }} />
        </IconButton>
      </Box>
    </Snackbar>
  );
};

export default NotificationSnackbar;